import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ApiService, OrderType, Table } from '@us/web/shared/data-access';
import { parseDataServer, validateDeliveryAddress } from '@us/web/shared/utils';
import { isNil } from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { map, Observable } from 'rxjs';
import { Cart } from './cart.reducer';
import { ENVIRONMENT } from '@us/app-config';

@Injectable({
    providedIn: 'root'
})
export class CartService {
    private readonly apiService = inject(ApiService);
    private readonly deviceService = inject(DeviceDetectorService);
    private readonly translocoService = inject(TranslocoService);
    private readonly env = inject(ENVIRONMENT);

    private readonly url = 'orders';

    constructor() {}

    submitCart(data: any): Observable<Cart> {
        return this.apiService.post(this.url, data).pipe(map(e => parseDataServer(e)));
    }

    public validateOrder(order: Cart) {
        // if (!this.shopService.inServiceTime()) {
        //     throw new Error(this.translocoService.translate('the_store_has_run_out_of_service_time'));
        // }

        if (isNil(order.order_type)) {
            throw new Error(this.translocoService.translate('please_select_the_form_of_delivery'));
        }

        if (order.order_type === OrderType.Delivery) {
            if (!order.receiver || !validateDeliveryAddress(order.receiver, order.order_type)) {
                throw new Error(this.translocoService.translate('please_fill_in_the_delivery_information'));
            }
        }

        if (order.order_type === OrderType.Delivery) {
            if (isNil(order.delivery) && this.env.appType !== 'retail') {
                throw new Error(this.translocoService.translate('please_select_a_delivery_partner'));
            }
        }

        if (order.order_type === OrderType.OrderAtTheTable) {
            if (isNil(order.order_table)) {
                throw new Error(this.translocoService.translate('please_select_a_table'));
            }
        }
    }

    validateTable(params: { tableId: number; shopId?: string }) {
        return this.apiService.post<Table>(`validate-table`, params);
    }
}
